export default async function ({ from, route, store, redirect, $firebase }) {
	const permissions = store.getters['user/permissions']
	const guestOnly = route.meta.some(m => m.guestOnly)
	const requiresAuth = route.meta.some(m => m.requiresAuth)
	const matchedRequiresAuthRole = route.meta.find(m => m.requiresAuthRole)
	const requiresAuthRole = matchedRequiresAuthRole ? matchedRequiresAuthRole.requiresAuthRole : 'user'

	if (route.params.logout) {
		store.dispatch('auth/logout')
	}

	if (!$firebase.initialized) {
		await $firebase.waitOnInitializedChanged()
	}

	const isAuthenticated = Boolean($firebase.auth?.currentUser)

	if (isAuthenticated && !permissions.hasAtlitUser) {
		await store.dispatch('user/fetchUser')
	}

	if (isAuthenticated && permissions.isIncompletePaidUser && !store.state.user.paymentUserFetched) {
		await store.dispatch('user/fetchPaymentUser')
	}

	if (isAuthenticated && store.getters['user/permissions'].hasSubscription &&
		!store.getters['user/permissions'].hasTeam &&
		store.getters['user/permissions'].hasUserEmail &&
		route.name !== 'create-team' &&
		route.name !== 'info-payment-payment-success') {
		return redirect(302, '/create-team/')
	}

	const routeContinueUrl = route.query?.continueUrl

	if (routeContinueUrl?.includes('play') || routeContinueUrl?.includes('club') || routeContinueUrl?.includes('advantage')) {
		const continueUrl = new URL(routeContinueUrl)
		const domain = continueUrl.origin
		const queryParams = new URLSearchParams(route.query)
		const redirectUrl = `${domain}/auth/redirect/?${queryParams.toString()}`
		return redirect(redirectUrl)
	}

	if (requiresAuth) {
		if (requiresAuthRole === 'admin') {
			if (!permissions.isEmailVerified) {
				store.dispatch('auth/logout')

				redirect('/login/')
			}

			if (store.getters['user/permissions'].isIncompletePaidUser && store.getters['user/permissions'].hasPaymentUser) {
				redirect({ name: 'login', query: { incompleteUser: true } })
			} else if (!store.getters['user/permissions'].hasPaymentUser) {
				redirect({ name: 'login', query: { isInvitedCoach: true } })
			}
		} else if (!isAuthenticated) {
			store.dispatch('auth/logout')

			return redirect('/login/')
		}
	} else if (guestOnly && isAuthenticated) {
		if (route.params.logout || route.params.keepSelection || route.query.incompleteUser) {
			// eslint-disable-next-line no-useless-return
			return
		} else if (permissions.isEmailVerified && !store.getters['user/permissions'].isIncompletePaidUser) {
			return redirect(302, '/profile/my-pixellot/')
		} else if (route.name !== 'login' && route.name !== 'auth-user-sign-up-success') {
			return redirect(302, '/events/')
		}
	}
}
